import React from 'react';
export function CommunicationHub() {
  return <div data-id="element-1329">
      <div className="flex justify-between items-center mb-6" data-id="element-1330">
        <h1 className="text-2xl font-bold" data-id="element-1331">Communication Hub</h1>
        <div className="space-x-2" data-id="element-1332">
          <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-1333">
            New Email
          </button>
          <button className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700" data-id="element-1334">
            New SMS
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1335">
        <div className="lg:col-span-1" data-id="element-1336">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-1337">
            <h2 className="text-lg font-medium mb-4" data-id="element-1338">Recent Contacts</h2>
            <div className="space-y-3" data-id="element-1339">
              <div className="p-3 hover:bg-neutral-100 rounded cursor-pointer" data-id="element-1340">
                <p className="font-medium" data-id="element-1341">John Doe</p>
                <p className="text-sm text-neutral-500" data-id="element-1342">
                  Last contact: 2 days ago
                </p>
              </div>
              <div className="p-3 hover:bg-neutral-100 rounded cursor-pointer" data-id="element-1343">
                <p className="font-medium" data-id="element-1344">Jane Smith</p>
                <p className="text-sm text-neutral-500" data-id="element-1345">
                  Last contact: 5 days ago
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-2" data-id="element-1346">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-1347">
            <h2 className="text-lg font-medium mb-4" data-id="element-1348">Communication History</h2>
            <div className="space-y-4" data-id="element-1349">
              <div className="border-b pb-4" data-id="element-1350">
                <div className="flex justify-between" data-id="element-1351">
                  <div data-id="element-1352">
                    <p className="font-medium" data-id="element-1353">Email to John Doe</p>
                    <p className="text-sm text-neutral-500" data-id="element-1354">
                      Subject: Policy Renewal
                    </p>
                  </div>
                  <p className="text-sm text-neutral-500" data-id="element-1355">Jan 15, 2023</p>
                </div>
                <p className="text-sm mt-2" data-id="element-1356">
                  This is a reminder about your upcoming policy renewal...
                </p>
              </div>
              <div className="border-b pb-4" data-id="element-1357">
                <div className="flex justify-between" data-id="element-1358">
                  <div data-id="element-1359">
                    <p className="font-medium" data-id="element-1360">SMS to Jane Smith</p>
                  </div>
                  <p className="text-sm text-neutral-500" data-id="element-1361">Jan 10, 2023</p>
                </div>
                <p className="text-sm mt-2" data-id="element-1362">
                  Your document has been received. Thank you!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}